<script>
	// images
	import CaseStudy from '$lib/Components/CaseStudy/CaseStudy.svelte';
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';

	import imageComfort from './images/customer-stories-hub-001.jpg';
	import imageEnergySaving from './images/customer-stories-hub-002.jpg';
	import imageNoiseReduction from './images/customer-stories-hub-003.jpg';
	import imageLightUvProtection from './images/customer-stories-hub-004.jpg';
	import imageHealthSafty from './images/customer-stories-hub-005.jpg';
	import imageCommercialProjects from './images/customer-stories-hub-006.png';
</script>

<Grid columns="3" rows="4" center>
	<CaseStudy
		subgrid
		title="comfort"
		src={imageComfort}
		description="Understanding the value of original windows, This Old House uses inserts to block drafts and noise in an 1847 home in Charleston’s historic district."
		href="/resources/case-studies/this-old-house-charleston"
		subtitle="This Old House in Charleston Installs Indow Inserts"
		headingLevel="h2"
	/>

	<CaseStudy
		subgrid
		title="Energy Savings"
		src={imageEnergySaving}
		description="The U.S. Department of Energy found Indow inserts lead to a 20 percent reduction in heating and cooling costs in a Seattle home."
		href="/resources/case-studies/energy-efficiency-old-homes"
		subtitle="U.S. Department of Energy Studies Indow Inserts in Seattle"
		headingLevel="h2"
	/>

	<CaseStudy
		subgrid
		title="Noise Reduction"
		src={imageNoiseReduction}
		description="Constant traffic noise made it hard for this family to sleep and almost forced them to move before they found Indow inserts."
		href="/resources/case-studies/street-noise-reduction"
		subtitle="Street Noise Reduction in the City Makes the Difference"
		headingLevel="h2"
	/>
</Grid>

<hr class="my-6" />

<Grid columns="3" rows="4" center>
	<CaseStudy
		subgrid
		title="Light & UV Protection"
		src={imageLightUvProtection}
		description="Owners of the iconic Case Study House #26 in California used inserts to protect paintings from damaging UV rays."
		href="/resources/case-studies/block-cold-from-windows"
		subtitle="Protecting artwork in an iconic American home"
		headingLevel="h2"
	/>

	<CaseStudy
		subgrid
		title="Health & Safety"
		src={imageHealthSafty}
		description="Privacy Grade inserts helped one urban dweller shield his home from view of hotel guests next door while reducing grime filtering through his windows."
		href="/resources/case-studies/window-privacy-ideas"
		subtitle="	Creating Privacy in an Urban Environment"
		headingLevel="h2"
	/>

	<CaseStudy
		subgrid
		title="Commercial Projects"
		src={imageCommercialProjects}
		description="This building manager installed Indow inserts to soundproof his tenants’ offices, and was blown away by the impressive reduction in sound."
		href="/resources/case-studies/office-soundproofing"
		subtitle="Office Soundproofing To Reduce Train Noise"
		headingLevel="h2"
	/>
</Grid>
